import {ANSWER_TYPE, ENROLMENT_TYPE, QUESTION_OPTION, QUESTION_TYPE} from '@common/consts/survey';

export function makeQuestions(questions, dateFormatFn) {
	if (questions[0].type === ANSWER_TYPE.PARENT_COUNSEL_WEEK) {
		const {parentCounselWeekQuestions, fcfsQuestions} = getParentCounselWeekQuestions(questions[0], dateFormatFn);

		return [
			...parentCounselWeekQuestions,
			...fcfsQuestions,
			...getQuestions(questions.slice(1), '', parentCounselWeekQuestions.length),
		];
	}
	return getQuestions(questions, '');
}

function getQuestions(questions, parentNumber, startQuestionNumber = 0) {
	let questionNumber = startQuestionNumber;

	return questions
		.filter(question => question.isUseQuestion)
		.flatMap((question, index) => {
			questionNumber++;
			const questionNumberText = parentNumber ? `${parentNumber}-${questionNumber}` : `${questionNumber}`;

			let questionType = QUESTION_TYPE.SURVEY;

			if (isSubTable(question)) {
				questionType = QUESTION_TYPE.SURVEY_TABLE;
			} else if (question.type === ANSWER_TYPE.SIGN) {
				questionType = QUESTION_TYPE.SURVEY_SIGN;
			}

			return [
				{
					questionNo: question.questionNo,
					parentQuestionNo: question.parentQuestion && question.parentQuestion.questionNo || null,
					questionType: questionType,
					questionNumber: questionNumberText,
					question: question.question,
					questionDesc: question.questionDesc,
					questionOptions: [
						...(question.type === ANSWER_TYPE.MULTI_CHOICE ? [{
							optionType: QUESTION_OPTION.MAX_CHOICE,
							optionValue: question.maxChoice,
						}] : []),

						...(hasAnswer(question) && question.isParentFCFS ? [{
							optionType: QUESTION_OPTION.IS_PARENT_FCFS,
							optionValue: 1,
						}] : []),

						{
							optionType: QUESTION_OPTION.MANDATORY,
							optionValue: (question.mandatory ? 1 : 0),
						},
					],
				},
				...(() => {
					if (!availableSubQuestions({question})) {
						return [];
					}
					if (question.type === ANSWER_TYPE.TABLE) {
						return getTableQuestions(question, questionNumberText);
					}
					if (question.isParentFCFS) {
						return getFCFSQuestions(question, questionNumberText);
					}
					return getQuestions(question.questions, questionNumberText);
				})(),
			];
		});
}

function getTableQuestions(question, questionNumberText) {

	let tableQuestions = [];
	if (question.tableQuestions?.length > 0) {
		tableQuestions = question.tableQuestions;
	} else if (question.questions?.length > 0) {
		tableQuestions = question.questions;
	}

	return getQuestions(tableQuestions, questionNumberText);
}

function getParentCounselWeekQuestions(question, dateFormatFn) {
	const parentCounselWeekQuestions = getQuestions(question.questions, '');
	const counselTimeQuestion = question.questions.find(question => question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK_TIME);
	const counselTimeQuestionIndex = question.questions
		.filter(question => question.isUseQuestion)
		.findIndex(question => question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK_TIME);

	const fcfsAnswers = [];
	for (let periodIndex = 0; periodIndex < counselTimeQuestion.counselPeriods.length; periodIndex++) {
		for (let timeSlotIndex = 0; timeSlotIndex < counselTimeQuestion.counselTimeSlots.length; timeSlotIndex++) {
			const time = counselTimeQuestion.counselTimes[periodIndex][timeSlotIndex];
			const limit = time.value;
			if (limit < 1) {
				continue;
			}

			const dayText = dateFormatFn(counselTimeQuestion.counselPeriods[periodIndex].value);
			const timeText = counselTimeQuestion.counselTimeSlots[timeSlotIndex];

			fcfsAnswers.push({
				answerNo: time.id,
				text: `${dayText}-${timeText}`,
				limit,
				reservedLimit: 0,
			});
		}
	}

	const counselTimeQuestionNumber = parentCounselWeekQuestions[counselTimeQuestionIndex].questionNumber;
	const fcfsQuestions = getFCFSQuestions(
		{
			...counselTimeQuestion,
			answers: fcfsAnswers,
		},
		counselTimeQuestionNumber,
	);

	const noTimeQuestion = parentCounselWeekQuestions.find(question => question.parentQuestionNo === counselTimeQuestion.questionNo);
	if (noTimeQuestion) {
		noTimeQuestion.questionNumber = noTimeQuestion.questionNumber.replace('-1', `-${fcfsQuestions.length + 1}`);
	}

	return {
		parentCounselWeekQuestions,
		fcfsQuestions,
	};
}

/**
 * 선착순 설문 - 보기를 질문으로 변환
 * @param parentQuestion
 * @param parentNumber
 * @returns {*}
 */
function getFCFSQuestions(parentQuestion, parentNumber) {
	return parentQuestion.answers.map((answer, index) => {
		return {
			questionNo: answer.answerNo,
			parentQuestionNo: parentQuestion.questionNo,
			questionType: QUESTION_TYPE.SURVEY_FCFS,
			questionNumber: makeQuestionNumber(parentNumber, index, 1),
			question: answer.text,
			questionDesc: null,
			questionOptions: [{
				optionType: QUESTION_OPTION.LIMIT,
				optionValue: answer.limit || 0,
			}, {
				optionType: QUESTION_OPTION.RESERVED_LIMIT,
				optionValue: answer.reservedLimit || 0,
			}, {
				optionType: QUESTION_OPTION.ENROLMENT_TYPE,
				optionValue: ENROLMENT_TYPE.FCFS,
			}],
		};
	});
}

export function makeQuestionNumber(parentNumber, index, startQuestionNumber) {
	if (parentNumber) {
		return `${parentNumber}-${index + 1}`;
	}

	return `${startQuestionNumber + index}`;
}

export function isSubTable(question) {
	return question.parentQuestion && question.parentQuestion.type === ANSWER_TYPE.TABLE;
}

export function hasAnswer(question) {
	return (question.type === ANSWER_TYPE.ONE_CHOICE || question.type === ANSWER_TYPE.MULTI_CHOICE) && !isSubTable(question);
}

export function availableSubQuestions({question}) {
	return question.type === ANSWER_TYPE.ONE_CHOICE ||
		question.type === ANSWER_TYPE.MULTI_CHOICE ||
		question.type === ANSWER_TYPE.TABLE ||
		question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK ||
		question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK_TIME;
}
